class PageLoader {
  constructor(element) {
    this.pageLoader = element;
    this.pageLoaderMessage = this.pageLoader.querySelector('[data-page-loader-message]') || null;
    this.loadingMode = this.pageLoader.dataset.pageLoader;
    
    this.isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);

    this.events();
  }
  
  displayLoader() {
    const loaderWrapper = document.createElement('div');
    loaderWrapper.classList.add('page-loader', 'd-f', 'ai-c', 'ac-c', 'jc-c', 'fw-w');

    const loaderElement = document.createElement('img');
    loaderElement.src = '/themes/siblu/dist/assets/img/loader-big.gif';
    loaderElement.alt = 'Page Loading...';
    loaderWrapper.prepend(loaderElement);
    
    if (this.pageLoaderMessage && this.pageLoaderMessage.dataset.pageLoaderMessage) {
      const loaderMessage = document.createElement('p');
      loaderMessage.classList.add('fs-s', 'fw-700', 'w-100', 'mb-m', 'c-darkest', 'ta-c');
      loaderMessage.innerText = this.pageLoaderMessage.dataset.pageLoaderMessage;
      loaderWrapper.prepend(loaderMessage);
    }

    this.pageLoader.before(loaderWrapper);

    document.getElementsByTagName('body')[0].classList.add('loading', 'o-h');
  }

  removeLoader() {
    const loaderWrapper = document.querySelector('.page-loader');
    loaderWrapper.remove();
    document.getElementsByTagName('body')[0].classList.remove('loading', 'o-h');
  }

  events() {
    if (this.loadingMode === 'leaving') {
      const eventName = this.isOnIOS ? "pagehide" : "beforeunload";
      window.addEventListener(eventName, () => {
        if (this.isOnIOS) {
          if (sessionStorage.getItem('pageLoaderOutDisplayed') && !sessionStorage.getItem('pageLoaderOutDisplayed').includes(window.location.pathname)) {
            sessionStorage.setItem('pageLoaderOutDisplayed', `${sessionStorage.getItem('pageLoaderOutDisplayed')}${window.location.pathname},`);
          } else {
            sessionStorage.setItem('pageLoaderOutDisplayed', `${window.location.pathname},`);
          }
        }
        // Timeout is needed for displaying the loader image, without it img won't display
        setTimeout(() => {
          this.pageLoaderMessage = this.pageLoader.querySelector('[data-page-loader-message]') || null;
          this.displayLoader();
        }, 0);
      });
    }

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible" && (navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i))) {
        // Check if loader has added on this page
        if (sessionStorage.getItem('pageLoaderOutDisplayed').includes(window.location.pathname)) {
          // Check if loader is always here and we are not on page with entering loader
          // Remove loader(s)
          setTimeout(function() {
            document.querySelectorAll('.page-loader').forEach(function(loaderWrapper) {
              loaderWrapper.remove();
            });
            document.getElementsByTagName('body')[0].classList.remove('loading', 'o-h');

            //Remove page from page's array displayed loader
            sessionStorage.setItem('pageLoaderOutDisplayed', sessionStorage.getItem('pageLoaderOutDisplayed').replace(`${window.location.pathname},`, ''));
          }, 0); // Timeout 0 is needed otherwise it doesn't find .page-loader
        }
      }
    });
    
    if (!this.isOnIOS) {
      window.onpageshow = (event) => {
        if (event.persisted && this.loadingMode !== 'entering' && document.getElementsByTagName('body')[0].classList.contains('loading')) {
          this.removeLoader();
        }
      };
    }
  }
}

const pageLoaders = document.querySelectorAll('[data-page-loader]');
pageLoaders.forEach((pageLoader) => {
  pageLoader.pageLoader = new PageLoader(pageLoader);
});